export { RelatedArticleCard as default } from './RelatedArticleCard';
